// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	font-family: "Poppins" !important;
}

body {
	background: #ffffff !important;
}

a {
	text-decoration: none !important;
	color: #05386b !important;
}

li {
	list-style: none;
	display: inline-block;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
	margin: 0 !important;
}

input,
textarea {
	border: none;
	outline: none;
}

button {
	border: none;
}

td {
	color: #6c6b79;
	vertical-align: middle;
	align-content: center;
	padding: 0.5rem !important;
	background-color: transparent !important;
}

th {
	background-color: transparent !important;
}

table {
	border-collapse: collapse;
}

table tbody tr:first-child {
	border-top: 1px solid rgb(222, 226, 230);
}

section {
	padding: 25px 20px;
}

section.Toastify {
	padding: 0;
}

.width-fit {
	width: fit-content !important;
}

.bg-white {
	background: #ffffff;
}

.min-block-height {
	min-height: calc(100vh - 166px);
}

.gradient-btn {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 18px;
	width: 114px;
	height: 38px;
	background: var(--button-background);
	border-radius: 36px;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: #000000 !important;
}

.gradient-xl {
	border: none;
	width: 254px;
	height: 56px;
	border-radius: 36px;
	font-style: normal;
	font-weight: 700;
	font-size: 18px;
	line-height: 20px;
}

.dashboard-body {
	box-shadow: 0px 0px 25px 5px rgba(66, 147, 208, 0.25);
	position: relative;
	padding: 10px 25px;
	background: #f3faff;
	border-radius: none;
}

.dark-button {
	background-color: #4a4b65;
	padding: 8px 40px;
	border-radius: 4px;
	color: #ffffff;
	box-shadow:
		0 1px 3px 0 rgba(0, 0, 0, 0.3),
		0 0 0 1px rgba(0, 0, 0, 0.04);
	transition: all 0.3s;
}

.dark-button:hover {
	color: #ffffff;
	background: #45465f;
}

.dark-button:disabled {
	opacity: 0.8;
}

.color-333 {
	color: #333333 !important;
}

.form-field-error {
	color: rgb(189, 30, 30);
	font-size: 0.8rem;
	margin-bottom: 10px;
	font-weight: 400;
}

.form-input-field {
	background-color: #f1f9ff !important;
	border: 0.5px solid #a8a8a87e;
	border-radius: 3px !important;
}

.form-input-field:focus {
	border: 0.5px solid #a8a8a87e;
	box-shadow: none !important;
}

.form-input-label {
	font-weight: 500;
	font-size: 13px;
	margin-bottom: 4px !important;
	color: #4a4b65;
}

.dropdown-item:active,
.dropdown-item:focus-visible {
	border: none !important;
	background-color: #e9ecef !important;
}

.modal-title {
	font-size: 1.1rem !important;
	color: #4a4b65;
}

.w-49 {
	width: 49%;
}

.PhoneInputInput {
	background-color: transparent;
}

.table-row-body:hover {
	background-color: rgba(66, 147, 208, 0.25);
}

.page-wrapper {
	padding: 20px;
}

.carousel-indicators {
	display: none !important;
}

.dropdown-without-triangle .dropdown-toggle::after {
	content: unset !important;
}

.max-width-td {
	max-width: 250px;
}

.wrapped-table-row {
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	text-align: center;
}

.wrapped-table-row.traceback {
	white-space: normal;
	text-overflow: unset;
	word-break: break-word;
}

.cursor-pointer {
	cursor: pointer;
}

.text-bold {
	font-weight: 700;
}

.nav-tabs {
	border: 0 !important;
}

.nav-tabs .nav-link {
	border: 1px solid rgba(0, 0, 0, 0.175) !important;
	border-bottom: 0 !important;
	margin-right: 3px;
	background-color: white !important;
	position: relative;
	z-index: 3;
}

.nav-tabs .nav-item .active::before {
	content: unset !important;
}

.nav-tabs .nav-item .nav-link {
	color: #4a4b65 !important;
	background-color: rgb(238 242 246) !important;
}

.nav-tabs .nav-item .active {
	background-color: white !important;
	font-weight: 500 !important;
}

.tab-content {
	border: 1px solid rgba(0, 0, 0, 0.175);
	border-radius: 10px;
	border-top-left-radius: 0px;
	padding: 0px 20px;
	padding-top: 5px;
}

.tab-content .active::before {
	content: unset !important;
}

section[id="shadow-host-companion"] {
	padding: 0;
}

.bold-text {
	font-weight: 500;
}

.dropdown-settings-button {
	border: 1px solid rgba(28, 111, 209, 0.5) !important;
	color: #1c6fd1 !important;
	background: #f1f9ff !important;
	padding: 4px 20px !important;
	font-weight: 400;
	font-size: 16px;
	margin: 0;
}

.review-block {
	display: flex;
	flex-direction: column;
	border-top: 1px solid rgba(75, 77, 88, 0.168);
	padding: 10px 3px;
}

.review-block:last-child {
	border-bottom: 1px solid rgba(75, 77, 88, 0.168);
}

.Toastify__toast.Toastify__toast-theme--light.Toastify__toast--error {
	padding-right: 20px;
}

.ice-button {
	background-color: #4db8ff;
	height: 44px;
	border-radius: 8px;
	padding: 0 16px;
	color: #ffffff;
	font-size: 16px;
	line-height: 20px;
	transition: 0.3s;
}

.ice-button:hover {
	background-color: #1da1f2;
	transition: 0.3s;
}

.ice-button:disabled {
	background-color: #4db8ff7c;
	transition: 0.3s;
}

.vertical-align-middle {
	vertical-align: middle;
}

.secondary-button {
	background-color: #ffffff;
	height: 44px;
	border-radius: 8px;
	padding: 0 16px;
	color: #191919;
	border: 1px solid #191919;
	transition: 0.3s;
}

.secondary-button:hover {
	color: #666666;
	border: 1px solid #666666;
	transition: 0.3s;
}

input {
	accent-color: #4db8ff;
}

.modal-content {
	border: none;
	border-radius: 10px;
}

.modal__title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 400;
	color: #191919;
}

.modal__header {
	border: none;
	padding: 16px;
}

.modal-700 .modal-dialog {
	max-width: 700px;
}

.modal-650 .modal-dialog {
	max-width: 650px;
}

.modal-600 .modal-dialog {
	max-width: 600px;
}

.modal-550 .modal-dialog {
	max-width: 550px;
}

.modal-500 .modal-dialog {
	max-width: 500px;
}

.modal-400 .modal-dialog {
	max-width: 400px;
}

.light-grey-button {
	background-color: #ffffff;
	height: 44px;
	border-radius: 8px;
	padding: 0 16px;
	color: #666666;
	border: 1px solid #e6e6e6;
	transition: 0.3s;
}

.light-grey-button:hover {
	color: #191919;
	border: 1px solid #191919;
	transition: 0.3s;
}

.default-input {
	height: 44px;
	width: 100%;
	padding: 0 16px;
	border: 1px solid var(--gray);
	border-radius: 6px;
	background-color: white;
}

input[type="checkbox"] {
	box-shadow: none !important;
	outline: none !important;
	cursor: pointer;
}

input:checked {
	background-color: #4db8ff !important;
	border: #4db8ff;
	box-shadow: none !important;
	outline: none !important;
}

.grey-color {
	color: #666666;
}

.default-table {
	background-color: #ffffff;
	padding: 12px;
	border-radius: 10px;
}

.default-table table,
.default-table-no-wrapper table {
	margin-bottom: 0;
}

.default-table-no-wrapper {
	background-color: #ffffff;
}

.default-table tr,
.default-table-no-wrapper tr {
	height: 64px;
}

.default-table tr th,
.default-table-no-wrapper tr th {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
	font-weight: 400;
	text-align: center;
	vertical-align: middle;
}

.default-table tr td,
.default-table-no-wrapper tr td {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 400;
}

.default-dropdown-toggle img {
	transition: 0.3s;
}

.default-dropdown-toggle.show img {
	transform: rotate(180deg);
	transition: 0.3s;
}

.default-dropdown-menu-wrapper {
	padding: 8px;
	border: 1px solid #e6e6e6;
}

.default-dropdown-menu {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.default-dropdown-item {
	width: 100%;
	height: 40px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	padding: 0 10px;
	font-size: 16px;
	line-height: 20px;
	color: #666666 !important;
}

.default-dropdown-item:hover {
	background-color: #f2f2f2 !important;
}

.default-dropdown-button {
	border: 1px solid #e6e6e6;
	padding: 0 12px;
	height: 44px;
	border-radius: 8px;
	background-color: #ffffff;
	color: #191919;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
}

.disabled-dropdown-item {
	background-color: #f2f2f2 !important;
	opacity: 0.4;
}

.rdrDefinedRangesWrapper {
	display: none;
}

.input-error {
	border: 1px solid red !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/assets/styles/globals.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;AAClC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;;;;;;;CAOC,oBAAoB;AACrB;;AAEA;;CAEC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,qBAAqB;CACrB,0BAA0B;CAC1B,wCAAwC;AACzC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,YAAY;CACZ,oCAAoC;CACpC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,qDAAqD;CACrD,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd;;+BAE8B;CAC9B,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,6BAA6B;CAC7B,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,6BAA6B;CAC7B,cAAc;AACf;;AAEA;;CAEC,uBAAuB;CACvB,oCAAoC;AACrC;;AAEA;CACC,4BAA4B;CAC5B,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iDAAiD;CACjD,2BAA2B;CAC3B,iBAAiB;CACjB,kCAAkC;CAClC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,6CAA6C;AAC9C;;AAEA;CACC,kCAAkC;CAClC,2BAA2B;AAC5B;;AAEA;CACC,sCAAsC;CACtC,mBAAmB;CACnB,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;CACzB,8BAA8B;CAC9B,4BAA4B;CAC5B,gBAAgB;CAChB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,6CAA6C;CAC7C,iBAAiB;AAClB;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,6BAA6B;CAC7B,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;CAC3B,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC,oCAAoC;CACpC,eAAe;CACf,2BAA2B;CAC3B,wBAAwB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;AACpB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;;CAEC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,QAAQ;AACT;;AAEA;CACC,oCAAoC;CACpC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gCAAgC;AACjC","sourcesContent":["* {\n\tfont-family: \"Poppins\" !important;\n}\n\nbody {\n\tbackground: #ffffff !important;\n}\n\na {\n\ttext-decoration: none !important;\n\tcolor: #05386b !important;\n}\n\nli {\n\tlist-style: none;\n\tdisplay: inline-block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n\tmargin: 0 !important;\n}\n\ninput,\ntextarea {\n\tborder: none;\n\toutline: none;\n}\n\nbutton {\n\tborder: none;\n}\n\ntd {\n\tcolor: #6c6b79;\n\tvertical-align: middle;\n\talign-content: center;\n\tpadding: 0.5rem !important;\n\tbackground-color: transparent !important;\n}\n\nth {\n\tbackground-color: transparent !important;\n}\n\ntable {\n\tborder-collapse: collapse;\n}\n\ntable tbody tr:first-child {\n\tborder-top: 1px solid rgb(222, 226, 230);\n}\n\nsection {\n\tpadding: 25px 20px;\n}\n\nsection.Toastify {\n\tpadding: 0;\n}\n\n.width-fit {\n\twidth: fit-content !important;\n}\n\n.bg-white {\n\tbackground: #ffffff;\n}\n\n.min-block-height {\n\tmin-height: calc(100vh - 166px);\n}\n\n.gradient-btn {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 18px;\n\twidth: 114px;\n\theight: 38px;\n\tbackground: var(--button-background);\n\tborder-radius: 36px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #000000 !important;\n}\n\n.gradient-xl {\n\tborder: none;\n\twidth: 254px;\n\theight: 56px;\n\tborder-radius: 36px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tfont-size: 18px;\n\tline-height: 20px;\n}\n\n.dashboard-body {\n\tbox-shadow: 0px 0px 25px 5px rgba(66, 147, 208, 0.25);\n\tposition: relative;\n\tpadding: 10px 25px;\n\tbackground: #f3faff;\n\tborder-radius: none;\n}\n\n.dark-button {\n\tbackground-color: #4a4b65;\n\tpadding: 8px 40px;\n\tborder-radius: 4px;\n\tcolor: #ffffff;\n\tbox-shadow:\n\t\t0 1px 3px 0 rgba(0, 0, 0, 0.3),\n\t\t0 0 0 1px rgba(0, 0, 0, 0.04);\n\ttransition: all 0.3s;\n}\n\n.dark-button:hover {\n\tcolor: #ffffff;\n\tbackground: #45465f;\n}\n\n.dark-button:disabled {\n\topacity: 0.8;\n}\n\n.color-333 {\n\tcolor: #333333 !important;\n}\n\n.form-field-error {\n\tcolor: rgb(189, 30, 30);\n\tfont-size: 0.8rem;\n\tmargin-bottom: 10px;\n\tfont-weight: 400;\n}\n\n.form-input-field {\n\tbackground-color: #f1f9ff !important;\n\tborder: 0.5px solid #a8a8a87e;\n\tborder-radius: 3px !important;\n}\n\n.form-input-field:focus {\n\tborder: 0.5px solid #a8a8a87e;\n\tbox-shadow: none !important;\n}\n\n.form-input-label {\n\tfont-weight: 500;\n\tfont-size: 13px;\n\tmargin-bottom: 4px !important;\n\tcolor: #4a4b65;\n}\n\n.dropdown-item:active,\n.dropdown-item:focus-visible {\n\tborder: none !important;\n\tbackground-color: #e9ecef !important;\n}\n\n.modal-title {\n\tfont-size: 1.1rem !important;\n\tcolor: #4a4b65;\n}\n\n.w-49 {\n\twidth: 49%;\n}\n\n.PhoneInputInput {\n\tbackground-color: transparent;\n}\n\n.table-row-body:hover {\n\tbackground-color: rgba(66, 147, 208, 0.25);\n}\n\n.page-wrapper {\n\tpadding: 20px;\n}\n\n.carousel-indicators {\n\tdisplay: none !important;\n}\n\n.dropdown-without-triangle .dropdown-toggle::after {\n\tcontent: unset !important;\n}\n\n.max-width-td {\n\tmax-width: 250px;\n}\n\n.wrapped-table-row {\n\tdisplay: block;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\ttext-align: center;\n}\n\n.wrapped-table-row.traceback {\n\twhite-space: normal;\n\ttext-overflow: unset;\n\tword-break: break-word;\n}\n\n.cursor-pointer {\n\tcursor: pointer;\n}\n\n.text-bold {\n\tfont-weight: 700;\n}\n\n.nav-tabs {\n\tborder: 0 !important;\n}\n\n.nav-tabs .nav-link {\n\tborder: 1px solid rgba(0, 0, 0, 0.175) !important;\n\tborder-bottom: 0 !important;\n\tmargin-right: 3px;\n\tbackground-color: white !important;\n\tposition: relative;\n\tz-index: 3;\n}\n\n.nav-tabs .nav-item .active::before {\n\tcontent: unset !important;\n}\n\n.nav-tabs .nav-item .nav-link {\n\tcolor: #4a4b65 !important;\n\tbackground-color: rgb(238 242 246) !important;\n}\n\n.nav-tabs .nav-item .active {\n\tbackground-color: white !important;\n\tfont-weight: 500 !important;\n}\n\n.tab-content {\n\tborder: 1px solid rgba(0, 0, 0, 0.175);\n\tborder-radius: 10px;\n\tborder-top-left-radius: 0px;\n\tpadding: 0px 20px;\n\tpadding-top: 5px;\n}\n\n.tab-content .active::before {\n\tcontent: unset !important;\n}\n\nsection[id=\"shadow-host-companion\"] {\n\tpadding: 0;\n}\n\n.bold-text {\n\tfont-weight: 500;\n}\n\n.dropdown-settings-button {\n\tborder: 1px solid rgba(28, 111, 209, 0.5) !important;\n\tcolor: #1c6fd1 !important;\n\tbackground: #f1f9ff !important;\n\tpadding: 4px 20px !important;\n\tfont-weight: 400;\n\tfont-size: 16px;\n\tmargin: 0;\n}\n\n.review-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder-top: 1px solid rgba(75, 77, 88, 0.168);\n\tpadding: 10px 3px;\n}\n\n.review-block:last-child {\n\tborder-bottom: 1px solid rgba(75, 77, 88, 0.168);\n}\n\n.Toastify__toast.Toastify__toast-theme--light.Toastify__toast--error {\n\tpadding-right: 20px;\n}\n\n.ice-button {\n\tbackground-color: #4db8ff;\n\theight: 44px;\n\tborder-radius: 8px;\n\tpadding: 0 16px;\n\tcolor: #ffffff;\n\tfont-size: 16px;\n\tline-height: 20px;\n\ttransition: 0.3s;\n}\n\n.ice-button:hover {\n\tbackground-color: #1da1f2;\n\ttransition: 0.3s;\n}\n\n.ice-button:disabled {\n\tbackground-color: #4db8ff7c;\n\ttransition: 0.3s;\n}\n\n.vertical-align-middle {\n\tvertical-align: middle;\n}\n\n.secondary-button {\n\tbackground-color: #ffffff;\n\theight: 44px;\n\tborder-radius: 8px;\n\tpadding: 0 16px;\n\tcolor: #191919;\n\tborder: 1px solid #191919;\n\ttransition: 0.3s;\n}\n\n.secondary-button:hover {\n\tcolor: #666666;\n\tborder: 1px solid #666666;\n\ttransition: 0.3s;\n}\n\ninput {\n\taccent-color: #4db8ff;\n}\n\n.modal-content {\n\tborder: none;\n\tborder-radius: 10px;\n}\n\n.modal__title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 400;\n\tcolor: #191919;\n}\n\n.modal__header {\n\tborder: none;\n\tpadding: 16px;\n}\n\n.modal-700 .modal-dialog {\n\tmax-width: 700px;\n}\n\n.modal-650 .modal-dialog {\n\tmax-width: 650px;\n}\n\n.modal-600 .modal-dialog {\n\tmax-width: 600px;\n}\n\n.modal-550 .modal-dialog {\n\tmax-width: 550px;\n}\n\n.modal-500 .modal-dialog {\n\tmax-width: 500px;\n}\n\n.modal-400 .modal-dialog {\n\tmax-width: 400px;\n}\n\n.light-grey-button {\n\tbackground-color: #ffffff;\n\theight: 44px;\n\tborder-radius: 8px;\n\tpadding: 0 16px;\n\tcolor: #666666;\n\tborder: 1px solid #e6e6e6;\n\ttransition: 0.3s;\n}\n\n.light-grey-button:hover {\n\tcolor: #191919;\n\tborder: 1px solid #191919;\n\ttransition: 0.3s;\n}\n\n.default-input {\n\theight: 44px;\n\twidth: 100%;\n\tpadding: 0 16px;\n\tborder: 1px solid var(--gray);\n\tborder-radius: 6px;\n\tbackground-color: white;\n}\n\ninput[type=\"checkbox\"] {\n\tbox-shadow: none !important;\n\toutline: none !important;\n\tcursor: pointer;\n}\n\ninput:checked {\n\tbackground-color: #4db8ff !important;\n\tborder: #4db8ff;\n\tbox-shadow: none !important;\n\toutline: none !important;\n}\n\n.grey-color {\n\tcolor: #666666;\n}\n\n.default-table {\n\tbackground-color: #ffffff;\n\tpadding: 12px;\n\tborder-radius: 10px;\n}\n\n.default-table table,\n.default-table-no-wrapper table {\n\tmargin-bottom: 0;\n}\n\n.default-table-no-wrapper {\n\tbackground-color: #ffffff;\n}\n\n.default-table tr,\n.default-table-no-wrapper tr {\n\theight: 64px;\n}\n\n.default-table tr th,\n.default-table-no-wrapper tr th {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n\tfont-weight: 400;\n\ttext-align: center;\n\tvertical-align: middle;\n}\n\n.default-table tr td,\n.default-table-no-wrapper tr td {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 400;\n}\n\n.default-dropdown-toggle img {\n\ttransition: 0.3s;\n}\n\n.default-dropdown-toggle.show img {\n\ttransform: rotate(180deg);\n\ttransition: 0.3s;\n}\n\n.default-dropdown-menu-wrapper {\n\tpadding: 8px;\n\tborder: 1px solid #e6e6e6;\n}\n\n.default-dropdown-menu {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.default-dropdown-item {\n\twidth: 100%;\n\theight: 40px;\n\tborder-radius: 6px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666 !important;\n}\n\n.default-dropdown-item:hover {\n\tbackground-color: #f2f2f2 !important;\n}\n\n.default-dropdown-button {\n\tborder: 1px solid #e6e6e6;\n\tpadding: 0 12px;\n\theight: 44px;\n\tborder-radius: 8px;\n\tbackground-color: #ffffff;\n\tcolor: #191919;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 8px;\n}\n\n.disabled-dropdown-item {\n\tbackground-color: #f2f2f2 !important;\n\topacity: 0.4;\n}\n\n.rdrDefinedRangesWrapper {\n\tdisplay: none;\n}\n\n.input-error {\n\tborder: 1px solid red !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
